import React from "react";
import { Container } from "../../SharedStyles/SharedStyles";
import { FooterCont } from "./Styles";

const Footer = () => {
  return (
    <Container>
      <FooterCont>
        
      </FooterCont>
    </Container>
  );
};

export default Footer;
